// ControlPanel.jsx
import React, { useState } from 'react';

const ControlPanel = () => {
  const [isAutoEnabled, setIsAutoEnabled] = useState(false);
  const [selectedDate, setSelectedDate] = useState('');

  return (
    <div className="flex items-center gap-3">
      <input 
        type="date" 
        value={selectedDate}
        onChange={(e) => setSelectedDate(e.target.value)}
        className="px-5 py-3 min-w-[12rem] rounded-xl border-[2px] border-light-blue  text-sm focus:outline-none focus:ring-2 focus:ring-primary-blue focus:border-transparent"
        placeholder="dd/mm/yy"
      />
    </div>
  );
};

export default ControlPanel;
